import React, { FC } from 'react';
import ChallengePackageOrder from '../components/challenge-package-order-summary/ChallengePackageOrder';
import { Stack, Box } from '@mui/material';
import moment from 'moment';
import { projectCouponCode } from 'src/pages/constants';
import { useChallengeProducts } from 'src/pages/subscription-new/hooks/useChallengeProducts';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {
  getMonthlyPricingDisplay,
  getPersonalCoachPricing,
  getChallengeIntervalString,
  getChallengeSelectionPreviewLine,
} from 'src/pages/subscription-new/utils/plans.util';
import { setIsPersonalCoachingAdded } from 'src/store/signup';
import PromoCode from 'src/components/fields/promo-code/promo-code';
import { Coupon } from '../../deprecated/payment/types';
import colors from 'src/styles/equalution/colors';
import { getFullPlanObj, useViewport } from 'src/lib/utils';
import { EffectivePlanObjType } from '../types';

type Props = {
  effectivePlanObj: EffectivePlanObjType;
  handleChangePlan: () => void;
  coupon?: Coupon;
  setCoupon: (coupon: Coupon | undefined) => void;
  isChallengeFlowWithUrlCode?: boolean;
  codeParam?: string | null;
  futureCommencement?: boolean;
  setFutureCommencement?: (futureCommencement: boolean) => void;
  isSistemaGiftActive: boolean;
};

export const ChallengeFlowOrderSummary: FC<Props> = ({
  effectivePlanObj,
  handleChangePlan,
  coupon,
  setCoupon,
  isChallengeFlowWithUrlCode = false,
  codeParam,
  futureCommencement,
  setFutureCommencement,
  isSistemaGiftActive,
}) => {
  const dispatch = useAppDispatch();

  const { challengeEndDate } = useChallengeProducts();

  const {
    allPlansSorted,
    selectedPlanId,
    challengePackageSelectedPlan,
    isFitherProjectUser,
    addonWeek,
    challengeSelectionPreview,
  } = useAppSelector(state => state.signUp);

  const personalCoachPrice = getPersonalCoachPricing(allPlansSorted);

  const handlePersonalCoachAddRemove = (value: boolean) => {
    dispatch(setIsPersonalCoachingAdded(value));
  };

  // Get original plan amount (before discount) for proper discount calculation
  const originalPlanObj = getFullPlanObj(
    allPlansSorted,
    selectedPlanId,
    addonWeek
  );
  const originalBillingAmount = originalPlanObj
    ? Number(originalPlanObj.unitAmount).toFixed(2)
    : Number(effectivePlanObj?.unitAmount).toFixed(2);

  const { isMobile } = useViewport();

  const intervalString = getChallengeIntervalString(selectedPlanId);

  const renewalDescriptionLine = getChallengeSelectionPreviewLine(
    challengeSelectionPreview,
    effectivePlanObj?.id,
    selectedPlanId,
    challengePackageSelectedPlan
  );

  return (
    <Stack display="flex" gap={5} flex={1} mb={2}>
      <ChallengePackageOrder
        bundleName={challengePackageSelectedPlan?.id || selectedPlanId}
        billingAmount={originalBillingAmount}
        originalPrice={challengePackageSelectedPlan?.originalPrice}
        isPersonalCoachingAdded={false}
        onRemovePersonalCoach={() => handlePersonalCoachAddRemove(false)}
        handleChangePlan={handleChangePlan}
        personalCoachPrice={Number(personalCoachPrice)}
        nextBillingDate={
          challengeEndDate
            ? moment(challengeEndDate).format('MMMM D, YYYY')
            : ''
        }
        nextBillingAmount={getMonthlyPricingDisplay()}
        coupon={coupon}
        intervalString={intervalString}
        isSistemaGiftActive={isSistemaGiftActive}
        renewalDescriptionLine={renewalDescriptionLine}
      />
      {isChallengeFlowWithUrlCode && (
        <Box
          sx={{
            width: isMobile ? 330 : '100%',
            marginLeft: isMobile ? '32px' : '0px',
          }}>
          <Box
            sx={{ textTransform: 'uppercase' }}
            fontSize={'12px'}
            color={colors.BLUEBERRY_HALF}>
            Promo Code
          </Box>
          <PromoCode
            prefillCode={
              isFitherProjectUser
                ? projectCouponCode
                : isChallengeFlowWithUrlCode
                ? codeParam ?? undefined
                : undefined
            }
            priceId={effectivePlanObj.id}
            coupon={coupon}
            setCoupon={setCoupon}
            finalPrice={parseFloat(effectivePlanObj.unitAmount.toString())}
            isFromSignUp={true}
            productId={effectivePlanObj.productId}
            futureCommencement={futureCommencement}
            setFutureCommencement={setFutureCommencement}
            readOnly={isChallengeFlowWithUrlCode}
            isChallengeFlowWithUrlCode={isChallengeFlowWithUrlCode}
          />
        </Box>
      )}
      {/* <OffersModule
        title="Maximise your transformation!"
        backgroundColor={colors.OFF_WHITE}>
        <SignupNutritionCoaching
          price={Number(personalCoachPrice)}
          isNutritionCoachingAdded={isPersonalCoachingAdded}
          onCtaClick={() => handlePersonalCoachAddRemove(true)}
        />
      </OffersModule> */}
    </Stack>
  );
};
